import {ChangeDetectionStrategy, Component, computed, Inject, Injectable, input, signal, Signal, viewChild} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {filter, Observable, scan, switchMap} from "rxjs";
import {takeUntilDestroyed, toObservable, toSignal} from "@angular/core/rxjs-interop";
import {AgendaelementId, BeslutningId, DokumentId, MøteId, OppgaveId, SaksdokumentModell, TilgangsrolleMedlem} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {AgendaelementModellDLM, SakDatatjeneste} from "felles-ng2/tjenester/datalager/SakDatatjeneste";
import {asynkArbeidPågårSignal} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";
import {tomAgendaelementModell} from "felles-ng2/modell/tommeModeller";
import {Sakstidspunkt, Sakstidspunkter} from "felles-ng2/tjenester/Sakstidspunkter";
import {RegistrerDokumentArkfane, RegistrerSaksdokumentDialogKomponent} from "../../modale/registrer-saksdokument-dialog/registrer-saksdokument-dialog";
import {SakRedigerKontroller} from "../sak-rediger/sak-rediger";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {lesMøtedato2} from "felles-ng2/modell/møteModellHjelpere";
import {Klokke} from "felles-ng2/tjenester/Klokke";
import {NavigasjonDeaktivering} from "web-ng2/tjenester/NavigasjonDeaktivering";
import {delay, map, shareReplay} from "rxjs/operators";
import {åpneINyttvindu} from "felles-ng2/støttefunksjoner/nettleser";
import {RessursAdresser} from "felles-ng2/tjenester/ressurser/RessursAdresser";
import {KopierSakDialogKomponent} from "../../modale/kopier-sak-dialog/kopier-sak-dialog";
import {MatDialog} from "@angular/material/dialog";
import {FlyttSakDialogKomponent} from "../../modale/flytt-sak-dialog/flytt-sak-dialog";
import {OppgaveOpprettDialogKomponent} from "../../../oppgave/modale/oppgave-opprett-dialog/oppgave-opprett-dialog";
import {BeslutningOpprettDialogKomponent} from "../../../beslutning/modale/beslutning-opprett-dialog/beslutning-opprett-dialog";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {SkjermingDialogKomponent} from "../../../skjerming/modale/skjerming-dialog/skjerming-dialog";
import {SkjermetEntitetType} from "felles-ng2/tjenester/datalager/SkjermingDatatjeneste";
import {erFavorittHosKallendeBruker} from "felles-ng2/modell/favoritterModellHjelpere";
import {AvatarKomponent} from "web-ng2/delt/komponenter/avatar/avatar";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {MatDivider} from "@angular/material/list";
import {TranslateModule} from "@ngx-translate/core";
import {MatIconButton, MatMiniFabButton} from "@angular/material/button";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";
import {SakListeBeslutningerKomponent} from "../sak-liste-beslutninger/sak-liste-beslutninger";
import {SakRedigerReferatKomponent} from "../sak-rediger-referat/sak-rediger-referat";
import {SakListeOppgaverKomponent} from "../sak-liste-oppgaver/sak-liste-oppgaver";
import {SakKommentarerKomponent} from "../sak-kommentarer/sak-kommentarer";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {ZoneddatetimeSomPlainTimePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainTimePipe";
import {FormaterPlainTimePipe} from "felles-ng2/pipes/FormaterPlainTimePipe";
import {ZonedDateTimeSomPlainDatePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainDatePipe";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {SakListeDokumenterKomponent, SaksdokumenterUnderOpplasting, SaksdokumenterUnderOpplasting_DI_TOKEN} from "../sak-liste-dokumenter/sak-liste-dokumenter";
import {FormaterDurationPipe} from "felles-ng2/pipes/FormaterDurationPipe";
import {TittelVerdiSamlingKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi-samling";
import {TittelKomponent, TittelVerdiKomponent, VerdiKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi";
import {erIkkeTomListe, erTomListe} from "felles-ng2/støttefunksjoner/lister";
import {beslutningsforslag, endeligeBeslutninger} from "felles-ng2/modell/beslutningModellHjelpere";
import {BeslutningDatatjeneste, BeslutningModellDLM} from "felles-ng2/tjenester/datalager/BeslutningDatatjeneste";
import {OppgaveDatatjeneste} from "felles-ng2/tjenester/datalager/OppgaveDatatjeneste";
import {SaksdokumentDatatjeneste} from "felles-ng2/tjenester/datalager/SaksdokumentDatatjeneste";
import {KommentarDatatjeneste} from "felles-ng2/tjenester/datalager/KommentarDatatjeneste";
import {DraOgSlippFilAktivertMeldingKomponent} from "web-ng2/delt/direktiver/draOgSlippFil/draOgSlippFilAktivertMelding";
import {DraOgSlippFilDirektiv} from "web-ng2/delt/direktiver/draOgSlippFil/draOgSlippFil";
import {dialogRespons} from "felles-ng2/infrastruktur/material/matDialogHjelpere";
import {erIkkeNil, erNil, gjørDersomIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {FabMenyKomponent} from "web-ng2/delt/komponenter/fab-meny/fab-meny";
import {ToggleKlasseVedStickyDirektiv} from "web-ng2/delt/direktiver/toggleKlasseVedSticky/toggleKlasseVedSticky";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {SakListeAvstemningerKomponent} from "web-ng2/moduler/sak/komponenter/sak-liste-avstemninger/sak-liste-avstemninger";
import {AvstemningDatatjeneste} from "felles-ng2/tjenester/datalager/AvstemningDatatjeneste";
import {RedigerAvstemningDialogKomponent} from "web-ng2/moduler/avstemning/modale/rediger-avstemning-dialog/rediger-avstemning-dialog";
import {BekreftKlikkDirektiv} from "web-ng2/delt/direktiver/button--bekreftKlikk/button--bekreftKlikk";
import {MøteDatatjeneste} from "felles-ng2/tjenester/datalager/MøteDatatjeneste";
import {Leveringsvalg} from "felles-ng2/tjenester/datalager/datatjeneste";
import {OppgaveListevisningKompaktKomponent} from "web-ng2/moduler/oppgave/komponenter/oppgave-listevisning-kompakt/oppgave-listevisning-kompakt";
import {BeslutningListevisningKompaktKomponent} from "web-ng2/moduler/beslutning/komponenter/beslutning-listevisning-kompakt/beslutning-listevisning-kompakt";
import {ajs_AjsUIRouterGlobals_DI_TOKEN, AjsUIRouterGlobals} from "web-ng2/tjenester/ajs/AjsUIRouterGlobals";
import {scrollTilSenter} from "web-ng2/delt/dom/scrollIntoView";
import {BrukerkontekstAdministrasjon} from "felles-ng2/tjenester/BrukerkontekstAdministrasjon";
import {AvstemningListevisningKomponent} from "web-ng2/moduler/avstemning/komponenter/avstemning-listevisning/avstemning-listevisning";
import {TemaMedBeskrivelseKomponent} from "web-ng2/moduler/sak/komponenter/tema-med-beskrivelse/tema-med-beskrivelse";
import {SaksdokumentOpplasting, SaksdokumentOpplastingFabrikk} from "web-ng2/moduler/sak/tjenester/SaksdokumentOpplasting";

const debug = initDebugger('SakVisKomponent');

/**
 * Viser sak og tilhørende detaljer som beskrivelse, referat, beslutninger, oppgaver, dokumenter, kommentarer
 */
@Component({
    selector: 'sak-vis',
    templateUrl: 'sak-vis.html',
    styleUrl: 'sak-vis.scss',
    host: {'data-testid': 'saksdetaljer'},
    imports: [
        SakRedigerKontroller,
        AvatarKomponent,
        MatIcon,
        MatTooltip,
        MatDivider,
        TranslateModule,
        MatIconButton,
        HtmlFormatertKomponent,
        SakListeBeslutningerKomponent,
        SakRedigerReferatKomponent,
        SakListeOppgaverKomponent,
        SakKommentarerKomponent,
        MatMiniFabButton,
        MatMenu,
        MatMenuItem,
        MatMenuTrigger,
        ZoneddatetimeSomPlainTimePipe,
        FormaterPlainTimePipe,
        ZonedDateTimeSomPlainDatePipe,
        FormaterPlainDatePipe,
        SakListeDokumenterKomponent,
        FormaterDurationPipe,
        TittelVerdiSamlingKomponent,
        TittelVerdiKomponent,
        VerdiKomponent,
        TittelKomponent,
        DraOgSlippFilAktivertMeldingKomponent,
        DraOgSlippFilDirektiv,
        FabMenyKomponent,
        ToggleKlasseVedStickyDirektiv,
        MatButtonToggleGroup,
        MatButtonToggle,
        ReactiveFormsModule,
        SakListeAvstemningerKomponent,
        BekreftKlikkDirektiv,
        TemaMedBeskrivelseKomponent
    ],
    providers: [{provide: SaksdokumenterUnderOpplasting_DI_TOKEN, useFactory: (komponent: SakVisKomponent) => komponent.saksdokumenterUnderOpplasting(), deps: [SakVisKomponent]}],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SakVisKomponent {

    private sakListeDokumenterKomponent = viewChild(SakListeDokumenterKomponent);
    private sakKommentarerKomponent = viewChild(SakKommentarerKomponent);

    id = input.required<AgendaelementId>();

    sak: Signal<AgendaelementModellDLM>;
    arbeider = asynkArbeidPågårSignal();
    redigeringMulig = computed(() =>
      this.kontekst.autentisertBruker().inneharTilgangsrolleIGruppe(TilgangsrolleMedlem.skrive, this.sak().eiendeGruppeId) &&
      !this.sak().moete.laastForRedigering);
    kopierMulig = computed(() => this.kontekst.autentisertBruker().inneharTilgangsrolleIGruppe(TilgangsrolleMedlem.skrive, this.sak().eiendeGruppeId));
    //ny oppgave kan opprettes selvom protokoll(møte) er låst
    nyOppgaveMulig = computed(() => this.kontekst.autentisertBruker().inneharTilgangsrolleIGruppe(TilgangsrolleMedlem.skrive, this.sak().eiendeGruppeId));
    moeteStartdatoPassert = computed(() => lesMøtedato2(this.sak().moete).erPassert(this.klokke));
    menyDeaktivert = this.navigasjonDeaktivering.navigasjonDeaktivertSomSignal

    sakstidspunkt: Signal<Sakstidspunkt>;
    erRedigerSak = signal(false);
    erRedigerReferat = signal(false);
    erFavoritt = computed(() => erFavorittHosKallendeBruker(this.sak(), this.kontekst.autentisertBruker()));

    dokumenterVisningsmodusKontroll = new FormControl<DokumenterVisningsmodus>('kort', {nonNullable: true});
    tvingVisKommentarer = signal(false);

    fabMenyAktivert = false;

    visDokumenter: Signal<boolean>;
    visOppgaver: Signal<boolean>;
    visAvstemninger: Signal<boolean>;
    visKommentarer: Signal<boolean>;
    visForslagTilBeslutninger: Signal<boolean>;
    visEndeligeBeslutninger: Signal<boolean>;

    private saksdokumentOpplasting: Signal<SaksdokumentOpplasting | null>;
    private ikkeFerdigeOpplastinger = computed(() => this.saksdokumentOpplasting()?.ikkeFerdigeOpplastinger() ?? []);


    constructor(private avhengigheter: SakVisKomponentAvhengigheter,
                private saksdokumentOpplastingFabrikk: SaksdokumentOpplastingFabrikk,
                private sakstidspunkterTjeneste: Sakstidspunkter,
                private navigasjon: Navigasjon,
                private navigasjonDeaktivering: NavigasjonDeaktivering,
                private ressursAdresser: RessursAdresser,
                private kontekst: BrukerkontekstTilbyder,
                private kontekstAdministrasjon: BrukerkontekstAdministrasjon,
                private klokke: Klokke,
                private dialog: MatDialog,
                @Inject(ajs_AjsUIRouterGlobals_DI_TOKEN) private ajsUIRouterGlobals: AjsUIRouterGlobals) {
        //siden det opprettes multiple abonnementer til sakSomObserverbar sørger vi her for at ikke hvert abonnement fører til et nytt kall til lastSak(..)
        const sakSomObserverbar = this.lastSak();

        this.sak = toSignal(sakSomObserverbar, {initialValue: tomAgendaelementModell()});
        this.sakstidspunkt = toSignal(
          sakSomObserverbar.pipe(
            switchMap(sak => this.sakstidspunkterTjeneste.forMøteSomObserverbar(sak.moete.id)),
            //dersom sak har blitt slettet eller flyttet KAN det være at vi får levert tidspunkter som ikke inneholder sak fordi takeUntilAjs$destroy ikke har hatt effekt enda
            filter(tidspunkter => tidspunkter.harForSak(this.sak().id)),
            map(tidspunkter => tidspunkter.forSak(this.sak().id))
          ),
          {initialValue: Sakstidspunkt.utenTidspunkt('')}
        );

        const harDokumenter = toSignal(sakSomObserverbar.pipe(switchMap(sak => this.avhengigheter.harDokumenter(sak.id))), {initialValue: false});
        this.visDokumenter = computed(() => harDokumenter() || (this.saksdokumentOpplasting()?.harIkkeFerdigeOpplastinger() ?? false));
        this.visOppgaver = toSignal(sakSomObserverbar.pipe(switchMap(sak => this.avhengigheter.harOppgaver(sak.id))), {initialValue: false});
        this.visAvstemninger = toSignal(sakSomObserverbar.pipe(switchMap(sak => this.avhengigheter.harAvstemminger(sak.id))), {initialValue: false});
        this.visKommentarer = toSignal(sakSomObserverbar.pipe(switchMap(sak => this.avhengigheter.harKommentarer(sak.id))), {initialValue: false});
        this.visForslagTilBeslutninger = toSignal(sakSomObserverbar.pipe(switchMap(sak => this.avhengigheter.beslutninger(sak.id).pipe(map(beslutninger =>
          erIkkeTomListe(beslutningsforslag(beslutninger)))))), {initialValue: false});
        this.visEndeligeBeslutninger = toSignal(sakSomObserverbar.pipe(switchMap(sak => this.avhengigheter.beslutninger(sak.id).pipe(map(beslutninger =>
          erIkkeTomListe(endeligeBeslutninger(beslutninger)))))), {initialValue: false});

        //sørg for å scrolle til forespurt oppgave/dokument/avstemning etc
        sakSomObserverbar.pipe(delay(500), takeUntilDestroyed())
          .subscribe(sak => this.scrollForespurtEntitet())

        //set visningsmodus basert på brukervalg
        gjørDersomIkkeNil(this.kontekst.autentisertBruker().brukervalg.arkivVisningsmodus, modus => this.dokumenterVisningsmodusKontroll.setValue(modus));
        //lagre valgt visningsmodus i brukervalg
        this.dokumenterVisningsmodusKontroll.valueChanges.pipe(takeUntilDestroyed()).subscribe(modus => this.kontekstAdministrasjon.oppdaterBrukervalg({arkivVisningsmodus: modus}));

        this.saksdokumentOpplasting = toSignal(sakSomObserverbar.pipe(map(sak => this.saksdokumentOpplastingFabrikk.forSak(sak))), {initialValue: null});
    }

    aktiverFabMeny() {
        this.fabMenyAktivert = true;
    }

    deaktiverFabMeny() {
        this.fabMenyAktivert = false;
    }

    aapneSaksdokument() {
        åpneINyttvindu(this.ressursAdresser.saksdokumentUrl(this.sak()));
    }

    redigerSak() {
        this.erRedigerSak.set(true);
    }

    redigerSakFerdig() {
        this.erRedigerSak.set(false);
    }

    async slettSak() {
        const sak = this.sak();
        //dette kallet fører til at lastSak(..) leverer 'undefined' - dette detekterer vi i konstruktør og går da til møtesiden
        await this.avhengigheter.slettSak(sak.id);
        await this.avhengigheter.relastMøte(sak.moete.id);
    }

    flyttSak() {
        FlyttSakDialogKomponent.vis(this.dialog, Promise.resolve(this.sak()))
    }

    kopierSak() {
        KopierSakDialogKomponent.vis(this.dialog, Promise.resolve(this.sak()))
    }

    nyOppgave() {
        OppgaveOpprettDialogKomponent.visOpprettUnderSak(this.dialog, this.sak());
    }

    nyAvstemning() {
        RedigerAvstemningDialogKomponent.visOpprettNy(this.dialog, this.sak().id, this.sak().eiendeGruppeId);
    }

    nyBeslutning() {
        BeslutningOpprettDialogKomponent.vis(this.dialog, this.sak(), !this.moeteStartdatoPassert());
    }

    nyKommentarTraad() {
        this.tvingVisKommentarer.set(true);
        //fungerer ikke med nårGuiErOppdatert - antar det er fordi vi denne ikke venter til hele det nestede komponent treet til SakKommentarerKomponent er tegnet ut
        setTimeout(() => this.sakKommentarerKomponent()?.settMarkørINyKommentartrådFelt(), 200);
    }

    redigerReferat() {
        this.erRedigerReferat.set(true);
    }

    redigerReferatAvsluttet(lagret: boolean) {
        this.erRedigerReferat.set(false);
    }

    async visRegistrerDokumentDialog() {
        const respons = await dialogRespons(RegistrerSaksdokumentDialogKomponent.vis(this.dialog, this.sak(), RegistrerDokumentArkfane.genererte));
        if (erNil(respons) || respons.avbrutt || erTomListe(respons.filerTilOpplasting)) return;
        await this.saksdokumentOpplasting()!.lastOppSaksdokumenter(respons.filerTilOpplasting);
    }

    /** Registrerer angitte filer som saksdokumenter (trigget via dra-og-slipp (DraOgSlippFilDirektiv)) */
    async filerValgtForOpplasting(filer: File[]) {
        await this.saksdokumentOpplasting()!.lastOppSaksdokumenter(filer);
    }

    draOgSlippFilStoettet() {
        return () => this.redigeringMulig()
    }

    async endreFavorittmarkering() {
        await this.avhengigheter.endreFavorittmarkering(this.sak());
    }

    navigerTilTema() {
        this.navigasjon.gåTilListeSakerKnyttetTilTema(this.sak());
    }

    navigerTilSakstype() {
        this.navigasjon.gåTilListeSakerKnyttetTilSakstype(this.sak());
    }

    redigerSkjerming() {
        SkjermingDialogKomponent.rediger(this.dialog, this.sak().id, SkjermetEntitetType.sak, this.sak().eiendeGruppeId);
    }

    /** Åpner inline visning av angitt dokument.
     * Eksponert offentlig for å kunne kalles av omsluttende komponent.
     * @return false dersom angitt dokument ikke finnes  */
    åpneDokumentInline(saksdokument: SaksdokumentModell): boolean {
        return this.sakListeDokumenterKomponent()!.åpneDokumentInline(saksdokument);
    }

    /** Laster angitt fil som ny versjon under angitt saksdokument.
     * Eksponert offentlig for å kunne kalles av omsluttende komponent. */
    async registrerNyDokumentversjon(saksdokument: SaksdokumentModell, fil: File) {
        await this.saksdokumentOpplasting()!.registrerNyDokumentversjon(saksdokument, fil);
    }

    saksdokumenterUnderOpplasting(): SaksdokumenterUnderOpplasting {
        return {
            ikkeFerdigeOpplastinger: () => this.ikkeFerdigeOpplastinger
        };
    }

    // hjelpemetoder

    /** Laster sak når id endres, sørger for at sak kun lastes én gang selv om det opprettes multiple subscriptions.
     * Håndtere også navigasjon til møtesiden dersom sak slettes. */
    private lastSak():Observable<AgendaelementModellDLM>     {
        return toObservable(this.id).pipe(
          switchMap(id => this.arbeider.startArbeidAvsluttVedLeveranse(this.avhengigheter.lastSak(id))),
          //når sak slettes returnerer lastSak(..) undefined, da må vi relaste møte (pga mulig endring i saksnummer) og gå til møtesiden
          scan((forrigeSak, nåværendeSak) => {
              if (nåværendeSak === undefined && erIkkeNil(forrigeSak)) {
                  this.avhengigheter.relastMøte(forrigeSak.moete.id);
                  this.navigasjon.gåTilMøte(forrigeSak.moete.id);
              }
              return nåværendeSak;
          }, tomAgendaelementModell() as AgendaelementModellDLM | undefined),
          //ikke lever videre dersom sak har blitt slettet
          filter(sak => sak !== undefined),
          //sørger for at ikke hver subscription fører til kall til avhengigheter.lastSak,
          //`refCount: true` slik at kilde unsubscribes når alle subscriptions har terminert
          shareReplay({ bufferSize: 1, refCount: true })
        );
    }

    /** scroller til forespurt entitet eller viser melding til bruker dersom forespurt oppgaveId/dokumentId/beslutningId/avstemningId ikke ble funnet */
    private scrollForespurtEntitet() {
        const forespurtOppgave = this.ajsUIRouterGlobals.params['oppgaveId'] as OppgaveId | null;
        if (erIkkeNil(forespurtOppgave))
            scrollTilSenter(OppgaveListevisningKompaktKomponent.scrollTilElementCssUttrykk(forespurtOppgave));

        let forespurtDokument = this.ajsUIRouterGlobals.params['dokumentId'] as DokumentId | null;
        if (erIkkeNil(forespurtDokument)){
            const dokumentKomponent = this.sakListeDokumenterKomponent()?.finnDokumentKomponent(forespurtDokument);
            if (erIkkeNil(dokumentKomponent)) {
                dokumentKomponent.scrollTil();
                if (this.ajsUIRouterGlobals.params['signer'] === true) dokumentKomponent.signer();
                //aktiverer preview av forespurt dokument
                else dokumentKomponent.aapneInline();
            }
        }

        let forespurtBeslutning = this.ajsUIRouterGlobals.params['beslutningId'] as BeslutningId | null;
        if (erIkkeNil(forespurtBeslutning))
            scrollTilSenter(BeslutningListevisningKompaktKomponent.scrollTilElementCssUttrykk(forespurtBeslutning));

        let forespurtAvstemning = this.ajsUIRouterGlobals.params['avstemningId'] as DokumentId | null;
        if (erIkkeNil(forespurtAvstemning))
            scrollTilSenter(AvstemningListevisningKomponent.scrollTilElementCssUttrykk(forespurtAvstemning));
    }
}

export type DokumenterVisningsmodus = 'liste' | 'kort';

@Injectable()
export class SakVisKomponentAvhengigheter {

    constructor(private sakDatatjeneste: SakDatatjeneste,
                private møteDatatjeneste: MøteDatatjeneste,
                private beslutningDatatjeneste: BeslutningDatatjeneste,
                private oppgaveDatatjeneste: OppgaveDatatjeneste,
                private avstemningDatatjeneste: AvstemningDatatjeneste,
                private saksdokumentDatatjeneste: SaksdokumentDatatjeneste,
                private kommentarDatatjeneste: KommentarDatatjeneste) {
    }

    beslutninger(id: AgendaelementId): Observable<BeslutningModellDLM[]> {
        return this.beslutningDatatjeneste.finnTilknyttetSakFraLokallager(id);
    }

    harDokumenter(id: AgendaelementId): Observable<boolean> {
        return this.saksdokumentDatatjeneste.finnTilknyttetSakFraLokallager(id).pipe(map(dok => dok.length > 0));
    }

    harOppgaver(id: AgendaelementId): Observable<boolean> {
        return this.oppgaveDatatjeneste.finnTilknyttetSakFraLokallager(id).pipe(map(oppgaver => oppgaver.length > 0));
    }

    harAvstemminger(id: AgendaelementId): Observable<boolean> {
        return this.avstemningDatatjeneste.finnTilknyttetSakFraLokallager(id).pipe(map(avstemninger => avstemninger.length > 0));
    }

    harKommentarer(id: AgendaelementId): Observable<boolean> {
        return this.kommentarDatatjeneste.finnTilknyttetFraLokallager(id).pipe(map(oppgaver => oppgaver.length > 0));
    }

    lastSak(id: AgendaelementId): Observable<AgendaelementModellDLM | undefined> {
        return this.sakDatatjeneste.hent(id, Leveringsvalg.lever_undefined_ved_slettet);
    }

    async slettSak(id: AgendaelementId): Promise<void> {
        await this.sakDatatjeneste.slett(id);
    }

    async relastMøte(møteId: MøteId): Promise<void> {
        await this.møteDatatjeneste.relast(møteId);
    }

    async endreFavorittmarkering(sak: AgendaelementModellDLM): Promise<void> {
        await this.sakDatatjeneste.endreFavorittmarkering(sak);
    }

}
